export const certificateCn = {
    xunjiadang:'证书管理',
    zhengshuzhuantai:'证件状态',
    quanxuan:'全部',
    wuxiao:'无效',
    youxiao:'有效',
    kaishishijian:'开始时间',
    jieshushijian:'结束时间',
    zhengshubianhao:'证书编号',
    zhengshumingcheng:'证书名称',
    sousuo:'搜索',
    xuhao:'序号',
    youxiaoqi:'有效期',
    daoqishijian:'到期时间',
    caozuo:'操作'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/certificate/certificateCn.js